import {
  isUkCountry,
  isUkS104Row,
  getUkMatchingRule,
} from "./ukTaxUi.js";
import { normalizeLang } from "./translations.js";

export function normalizeCountryCode(country = "DE") {
  return String(country || "DE").trim().toUpperCase().replace(/\s+/g, "_");
}

export function isItalyCountry(country = "") {
  const cc = normalizeCountryCode(country);
  return cc === "IT" || cc === "ITA" || cc === "ITALY";
}

export function resolveEffectiveCountry(selectedCountry = "", row = {}) {
  const fromRow = row?.countryCode || row?.country || row?.selectedCountry || "";

  if (typeof window !== "undefined") {
    const fromUrl = new URLSearchParams(window.location.search).get("country");
    if (fromUrl && !selectedCountry && !fromRow) {
      return normalizeCountryCode(fromUrl);
    }
  }

  return normalizeCountryCode(selectedCountry || fromRow || "DE");
}

export function collectAssignmentLegs(row = {}, extraLegs = []) {
  const legs = [];

  if (Array.isArray(row?.fifoLegs)) legs.push(...row.fifoLegs);
  if (Array.isArray(row?.matchedInflows)) legs.push(...row.matchedInflows);
  if (Array.isArray(extraLegs)) legs.push(...extraLegs);

  return legs;
}

/** UK labels wenn Land UK ist oder Legs UK-S104-Markierungen tragen. */
export function shouldUseUkAssignmentLabels(selectedCountry = "", row = {}, extraLegs = []) {
  const cc = normalizeCountryCode(selectedCountry);

  if (isUkCountry(cc)) return true;
  if (isUkS104Row(row, cc)) return true;

  const method = String(row?.costBasisMethod || row?.ukMethod || "").toUpperCase();
  if (method === "UK_S104_POOLING" || method === "UK_NFT_IDENTIFIABLE") return true;

  if (getUkMatchingRule(row)) return true;

  const legs = collectAssignmentLegs(row, extraLegs);

  return legs.some(
    (leg) =>
      Boolean(getUkMatchingRule(leg)) ||
      isUkS104Row(leg, cc) ||
      leg?.isUkS104 === true
  );
}

export function getAssignmentMethodLabel(
  selectedCountry = "DE",
  row = {},
  extraLegs = [],
  language = "en"
) {
  const lang = normalizeLang(language);

  if (shouldUseUkAssignmentLabels(selectedCountry, row, extraLegs)) {
    return lang === "de" ? "UK-Matching-Zuordnung" : "UK matching assignment";
  }

  if (isItalyCountry(selectedCountry)) {
    return lang === "de" ? "LIFO-Zuordnung" : "LIFO Assignment";
  }

  return lang === "de" ? "FIFO-Zuordnung" : "FIFO Assignment";
}

export function getAssignmentTitle(
  tokenSymbol,
  selectedCountry = "DE",
  language = "en",
  row = {},
  extraLegs = []
) {
  const token = String(tokenSymbol || "").trim() || "—";
  const lang = normalizeLang(language);
  const methodLabel = getAssignmentMethodLabel(selectedCountry, row, extraLegs, language);
  const forWord = lang === "de" ? "für" : "for";

  return `${methodLabel} ${forWord} ${token}`;
}

export function getSaleDetailTitle(
  selectedCountry = "DE",
  language = "en",
  row = {},
  extraLegs = []
) {
  const lang = normalizeLang(language);

  if (shouldUseUkAssignmentLabels(selectedCountry, row, extraLegs)) {
    return lang === "de"
      ? "UK-Steuerbewertung für Verkauf"
      : "UK tax assessment for sale";
  }

  if (isItalyCountry(selectedCountry)) {
    return lang === "de"
      ? "LIFO-Steuerbewertung für Verkauf"
      : "LIFO tax assessment for sale";
  }

  return lang === "de"
    ? "Steuerliche Bewertung für Verkauf"
    : "Tax assessment for sale";
}
